import styled from 'styled-components';

export const LogoIcon = styled.img<{ collapsed: boolean }>`
  display: block;
  height: 45px;
  margin: 20px auto;
  object-fit: contain;
  transition: all 0.3s ease-in;
  width: 45px;
  ${(props: any) =>
    props.collapsed ? 'opacity: 1' : 'opacity: 0; display: none;'}
`;

export const LogoWide = styled.img<{ collapsed: boolean }>`
  display: block;
  height: 48px;
  margin: 20px auto;
  object-fit: contain;
  transition: all 0.3s ease-in;
  width: 48px;
  ${(props: any) =>
    props.collapsed ? 'opacity: 0; display:none;' : 'opacity: 1;'}
`;

const Default = {
  sideMenu: {
    borderRight: 0,
    height: '100%',
  },
};
export default Default;
